exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rom-preview {\n  max-width: 100%;\n  padding: 30px 15px;\n}\n.rom-wrapper {\n  position: relative;\n}\n.rom-file-or-resource-wrapper {\n  margin-top: 20px;\n}\n.rom-file-or-resource-string {\n  display: inline-block;\n  font-weight: 700;\n  font-style: italic;\n  padding: 0 10px;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", ""]);

// exports
